export class FavoriteItem {
    constructor(favoritePair = "") {
        const pairs = favoritePair.split(";");
        if (pairs.length === 2) {
            this.setValues(pairs[0], pairs[1]);
        }
    }
    setValues(sportId, eventId) {
        this.sportId = sportId;
        this.eventId = eventId;
    }
    stringify() {
        return this.sportId && this.eventId
            ? `${this.sportId};${this.eventId}`
            : "";
    }
}
//# sourceMappingURL=FavoriteItem.js.map